import css from './kkb.module.scss';

import { memo } from 'react';

const Kkb: React.FC<{ children: string | number; className?: string }> = ({
  children,
  className = '',
}) => <span className={`${className} ${css.kkb}`}>[{children}]</span>;

export default memo(Kkb);
